export default "__VITE_ASSET__vIYUI6uK__"